import methods from './methods';


export default {
    getAll: ({ email, year, month }, endpoint = '/hours') => methods.post(endpoint, { email, year, month }),
};
